import { __require as p } from "./_baseAssignValue.js";
import { __require as f } from "./_baseForOwn.js";
import { __require as l } from "./_baseIteratee.js";
var e, s;
function c() {
  if (s) return e;
  s = 1;
  var i = p(), n = f(), o = l();
  function _(t, r) {
    var a = {};
    return r = o(r, 3), n(t, function(q, u, m) {
      i(a, u, r(q, u, m));
    }), a;
  }
  return e = _, e;
}
export {
  c as __require
};
